module.exports = __webpack_public_path__ + "static/icon-menu-cdn.b94f6469.svg";